import {
   NASA_PHOTOS_FETCH_ERROR,
   NASA_PHOTOS_FETCH_LOADING,
   NASA_PHOTOS_FETCH_SUCCESS,
   NASA_PHOTOS_ADD_FAVOURITE
} from './type'

export const FETCH_LOADING: NASA_PHOTOS_FETCH_LOADING = 'NASA_PHOTOS_FETCH_LOADING'
export const FETCH_SUCCESS: NASA_PHOTOS_FETCH_SUCCESS = 'NASA_PHOTOS_FETCH_SUCCESS'
export const FETCH_ERROR: NASA_PHOTOS_FETCH_ERROR = 'NASA_PHOTOS_FETCH_ERROR'
export const ADD_FAVOURITE: NASA_PHOTOS_ADD_FAVOURITE = 'NASA_PHOTOS_ADD_FAVOURITE'
